import { gsap } from 'gsap/all'

const accordion = {
  el: {
    accordions: <NodeListOf<HTMLElement>>document.querySelectorAll('.accordion'),
  },

  init(): void {
    if (!this.el.accordions.length) return

    this.el.accordions.forEach((accordion: HTMLElement) => {
      const items = <NodeListOf<HTMLElement>>(
        accordion.querySelectorAll('.accordion__item')
      )

      items.forEach((item: HTMLElement) => {
        const head = <HTMLElement>item.querySelector('.accordion__head')

        head.addEventListener('click', () => {
          this.toggleItem(item)
        })
      })
    })
  },

  closeItem(item: HTMLElement): void {
    gsap.to(<HTMLElement>item.querySelector('.accordion__body'), {
      clearProps: 'all',
      duration: 0.5,
      ease: 'power3.inOut',
      height: 0,
      opacity: 0,
      onStart: () => {
        item.querySelector('.accordion__head').ariaExpanded = 'false'
        item.classList.remove('accordion__item--selected')
      },
    })
  },

  openItem(item: HTMLElement): void {
    gsap.fromTo(
      <HTMLElement>item.querySelector('.accordion__body'),
      {
        height: 0,
        opacity: 0,
      },
      {
        clearProps: 'all',
        duration: 0.5,
        ease: 'power3.inOut',
        height: 'auto',
        opacity: 1,
        onStart: () => {
          item.querySelector('.accordion__head').ariaExpanded = 'true'
          item.classList.add('accordion__item--selected')
        },
      }
    )
  },

  toggleItem(item: HTMLElement): void {
    const isSelected = item.classList.contains('accordion__item--selected')
    const currentlySelected = <HTMLElement>(
      item.closest('.accordion').querySelector('.accordion__item--selected')
    )

    if (currentlySelected) this.closeItem(currentlySelected)

    if (isSelected) {
      this.closeItem(item)
    } else {
      this.openItem(item)
    }
  },
}

export default accordion
